(() => {
  const MIN_TILES_FOR_ARROWS = 6;
  const ROOT_SELECTOR = '.product--grid-gallery .pdp-fyp';

  const getTilesContainer = (root) =>
    root.querySelector('.tolstoy-stories-tiles-container') ||
    root.querySelector('[data-tolstoy-element*="tolstoy-stories-tiles-container"]') ||
    root.querySelector('[class*="tolstoy-stories-tiles"]');

  const getTiles = (root) => {
    const container = getTilesContainer(root);
    if (!container) return [];

    return Array.from(container.querySelectorAll('[data-tolstoy-element]')).filter((tile) => {
      if (tile === container || tile.matches('[data-tolstoy-element*="tiles-container"]')) return false;
      const rect = tile.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  };

  const shouldShowArrows = (root) => {
    const tiles = getTiles(root);
    if (tiles.length === 0) return null;
    return tiles.length > MIN_TILES_FOR_ARROWS;
  };

  const updateOverflowState = (root) => {
    const showArrows = shouldShowArrows(root);
    if (showArrows === null) return;

    const nextState = showArrows ? '1' : '0';
    if (root.dataset.tolstoyOverflow === nextState) return;

    root.dataset.tolstoyOverflow = nextState;
    root.classList.toggle('has-tolstoy-overflow', showArrows);
  };

  const initRoot = (root) => {
    if (root.dataset.tolstoyArrowsReady === 'true') return;
    root.dataset.tolstoyArrowsReady = 'true';

    let scheduled = false;
    const run = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateOverflowState(root);
      });
    };

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(run);
      resizeObserver.observe(root);
      const tilesContainer = getTilesContainer(root);
      if (tilesContainer) resizeObserver.observe(tilesContainer);
    }

    const observer = new MutationObserver(() => {
      run();
      const tilesContainer = getTilesContainer(root);
      if (tilesContainer && resizeObserver) resizeObserver.observe(tilesContainer);
    });
    observer.observe(root, { childList: true, subtree: true });

    window.addEventListener('resize', run);
    run();
    [400, 800, 1200, 2000, 3500, 5000].forEach((ms) => setTimeout(run, ms));
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
